/* eslint-disable react/react-in-jsx-scope */
import React, { useRef, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Menu } from 'primereact/menu';
import { TabPanel, TabView } from "primereact/tabview";
import { UserInitialIcon } from '../../../components/userInitialIcon/UserInitialIcon';
import { Notification } from '../../../utils/typeConstants'
import { convertUTCtoDateTimeFormat } from '../../../utils/dateFormat'
import './Notification.scss'
import { useUpdateNotificationMutation, useDeleteNotificationMutation } from './notificationSlice';


export interface NotificationData {
    notification: Notification[],
    employeeNumber: string
}

interface NotificationItemProps {
    userName: string;
    subject: string;
    read: boolean;
    text: string;
    employeeNumber: string,
    notificationId: number,
    createdDate: string
}

const NotificationItem = (props: NotificationItemProps) => {
    const menu = useRef<Menu>(null);
    let items = [];
    const [UpdateNotification] = useUpdateNotificationMutation();
    const [DeleteNotification] = useDeleteNotificationMutation();
    const [isTextVisible, setIsTextVisible] = useState(false);
    const [isRead, setIsRead] = useState(true); 

    const handleToggleText = () => {
        window.localStorage.notificationId = props.notificationId;
        setIsTextVisible(!isTextVisible);
        if (!props.read) {
            const notification = {
                "employeenumber": props.employeeNumber,
                "isNotificationRead": true,
                "notificationId": props.notificationId,
                "readAll": false
            }
            UpdateNotification(notification)
                .unwrap()
                .then((response: any) => {
                    console.log(response)
                })
                .then((error: any) => {
                    console.log(error)
                });
        }

    };

    if (!isRead) {
        items.push({
            label: 'Mark as Read',
            icon: 'pi pi-bell',
            visible: true,
            command: () => {
                handleMarkasRead();
            },
        }, {
            label: 'Delete',
            icon: 'pi pi-trash',
            visible: true,
            command: () => {
                handleDelete();
            }
        })
    }
    if (isRead) {
        items.push({
            label: 'Mark as Unread',
            icon: 'pi pi-bell',
            visible: true,
            command: () => {
                handleMarkAsUnread();
            },
        }, {
            label: 'Delete',
            icon: 'pi pi-trash',
            visible: true,
            command: () => {
                handleDelete();
            }
        })
    }
    const popupMenuClickHandler = (e: any, isRead: boolean) => {
        e.preventDefault();
        menu.current?.toggle(e);
        setIsRead(isRead)
        items = []
    };

    const handleDelete = () => {
        const notification = {
            "employeenumber": props.employeeNumber,
            "notificationId": props.notificationId,
        }
        DeleteNotification(notification)
            .unwrap()
            .then((response: any) => {
                console.log(response)
            })
            .then((error: any) => {
                console.log(error)
            });
    }

    const handleMarkAsUnread = () => {
        const notification = {
            "employeenumber": props.employeeNumber,
            "isNotificationRead": false,
            "notificationId": props.notificationId,
            "readAll": false
        }
        UpdateNotification(notification)
            .unwrap()
            .then((response: any) => {
                console.log(response)
            })
            .then((error: any) => {
                console.log(error)
            });
    }

    const handleMarkasRead = () => {
        const notification = {
            "employeenumber": props.employeeNumber,
            "isNotificationRead": true,
            "notificationId": props.notificationId,
            "readAll": false
        }
        UpdateNotification(notification)
            .unwrap()
            .then((response: any) => {
                console.log(response)
            })
            .then((error: any) => {
                console.log(error)
            });
    }

    const returnSubject = () => {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-to-interactive-role
            <p role="button" className={!props.read ? 'unread' : 'read'} onClick={handleToggleText} > {props.subject}</p>
        )
    }
    return (
        <>
            <Menu model={items} popup ref={menu} id="popup_menu" />
            <div className="row m-t-10 custom-row">
                <div className="col-md-1">
                    <UserInitialIcon user={props.userName} iHeight="50px" iWidth="50px" iFontSize="20px" />
                </div>
                <div className="col-md-9">
                    {returnSubject()}
                    <div className="m-t-10 m-b-10 flex-space-between f-14">
                <span className={!props.read ? 'unread' : 'read'} >By {props.userName}</span>
                <span className={!props.read ? 'unread' : 'read'} >{convertUTCtoDateTimeFormat(props.createdDate)}</span>
            </div>
                    {isTextVisible && <p
                    style={{
                        border: '1px solid lightgray',
                        fontWeight: 'normal',
                        borderRadius: '10px',
                        padding: '10px',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{ __html: props.text }}/>}
                </div>
                <div className="col-md-1 flex-end">
                    {!props.read && window.localStorage.notificationId === props.notificationId && <div className="unread-indicator">&nbsp;
                    </div>}
                    {!props.read && <div className="unread-indicator">&nbsp;
                    </div>}
                </div>
                <div className="col-md-1 flex-end ">
                    <div
                        onClick={(e: any) => popupMenuClickHandler(e, props.read)}
                        aria-controls="popup_menu"
                        aria-haspopup
                        aria-hidden="true"
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="pi pi-ellipsis-v" style={{ fontSize: '1.2em' }} />
                    </div>

                </div>
            </div>
        </>

    );

}

export const Notifications = (props: NotificationData) => {
    const [notificationData, setNotificationData] = useState<Notification[]>([])
    const [UpdateNotification] = useUpdateNotificationMutation();
    const [readNotification, setReadNotification] = useState<Notification[]>([])
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const handleMarkAllRead = () => {
        const notification = {
            "employeenumber": props.employeeNumber,
            "isNotificationRead": true,
            "notificationId": 0,
            "readAll": true
        }
        UpdateNotification(notification)
            .unwrap()
            .then((response: any) => {
                console.log(response)
            })
            .then((error: any) => {
                console.log(error)
            });
    };
    useEffect(() => {
        const data = props.notification.map((item: Notification) => {
            return {
                ...item,
                localNotificationRead: window.localStorage.notificationId === item.notification_id.toString()
            }
        })
        setReadNotification(data.filter((item: any) => item.notification_read === false || item.localNotificationRead === true))
        setNotificationData(data)
    }, [props.notification, activeIndex])

    return (
        <TabView activeIndex={activeIndex} onTabChange={(e) => {
            window.localStorage.notificationId = '';
            setActiveIndex(e.index);
        }}>
            <TabPanel header="Unread">
                <div style={{ height: 'auto', maxHeight: '550px', overflow: 'auto' }}>
                    {readNotification.length > 0 ? (
                        readNotification.map((item, index) => (
                            <NotificationItem
                                key={index}
                                userName={item.sender_name}
                                subject={item.notification_subject}
                                read={item.notification_read}
                                text={item.notification_text}
                                employeeNumber={props.employeeNumber}
                                notificationId={item.notification_id}
                                createdDate={item.create_date}
                            />
                        ))
                    ) : (
                        <p style={{ marginTop: '20px' }}>No notifications available</p>
                    )}
                </div>

                <Button
                    className="btn-primary float-end mb-2"
                    // style={{ borderRadius: '8px', float: 'right' }}
                    onClick={handleMarkAllRead}
                >
                    Mark All As Read
                </Button>

            </TabPanel>
            <TabPanel header="View all">
                <div style={{ height: 'auto', maxHeight: '550px',  overflow: 'auto' }}>
                    {notificationData.length > 0 ? (
                        notificationData.map((item, index) => (
                            <NotificationItem
                                key={index}
                                userName={item.sender_name}
                                subject={item.notification_subject}
                                read={item.notification_read}
                                text={item.notification_text}
                                employeeNumber={props.employeeNumber}
                                notificationId={item.notification_id}
                                createdDate={item.create_date}
                            />
                        ))
                    ) : (
                        <p style={{ marginTop: '20px' }}>No notifications available</p>
                    )}
                </div>
            </TabPanel>
        </TabView>
    )

};